import React,{useState,useEffect} from 'react'
import ScreenSizes from '../../../configTools/screenSizes';
import { Navigate, useParams } from 'react-router-dom'
import OldRegister from '../../../../pages/public/register2'
import '../../../css/public/signup.css'
import Mobile from './mobile';

const Index = () => {
  const [screenSize, setScreenSize] = useState(getCurrentDimension());

  function getCurrentDimension(){
    return {
        width: window.innerWidth,
        height: window.innerHeight
    }
  }

  useEffect(() => {
      const updateDimension = () => {
          setScreenSize(getCurrentDimension())
      }
      window.addEventListener('resize', updateDimension);
  
  
      return(() => {
          window.removeEventListener('resize', updateDimension);
      })
  }, [screenSize])
  
  const User = JSON.parse(localStorage.getItem("user-info"));
  const {redirecturi} = useParams();
  if(User){
      if(User.role === 'admin'){
          if(redirecturi){
              if(redirecturi.includes("admin")){
                  console.log(redirecturi);
                  return <Navigate to={redirecturi}/>
              }
              else{
                  return <Navigate to="/admin"/>
              }
          }
          else{
              return <Navigate to="/admin"/>
          }
      }
      else{
          return <Navigate to={"/user/"+User.username}/>
      }
  }
  else{
      return(
          <>
              {screenSize.width > ScreenSizes.Mobile &&
               <OldRegister/>   
              }
              {screenSize.width <= ScreenSizes.Mobile &&
                <Mobile/>
              }
          </>
      )
  }
}

export default Index
